globalThis.PlayerController = class PlayerController {
  constructor(player) {
    this.player = player;
    this.config = player.config;
    this.keys = [];
    this.last_key = 0;
    this.last_key_time = 0;
    this.abort = new AbortController();
    addEventListener("keydown", this.onKeydown.bind(this), this.abort);
    addEventListener("keyup", this.onKeyup.bind(this), this.abort);
  }

  remove() {
    this.abort.abort();
  }

  onKeydown(event) {
    if (this.keys[event.keyCode]) return;
    this.keys[event.keyCode] = true;
    const time_since = Date.now() - this.last_key_time;
    const double =
      this.last_key === event.keyCode &&
      time_since < globalThis.DOUBLE_PRESS_TIMEOUT;
    this.last_key = event.keyCode;
    this.last_key_time = Date.now();
    switch (event.keyCode) {
      case this.config.left_key:
      case this.config.right_key:
        this.applyMovement(double);
        break;
      case this.config.up_key:
        if (this.player.floating) this.applyVerticalMovement();
        else this.player.jump();
        break;
      case this.config.down_key:
        this.applyVerticalMovement();
        break;
    }
  }

  onKeyup(event) {
    delete this.keys[event.keyCode];
    switch (event.keyCode) {
      case this.config.left_key:
      case this.config.right_key:
        this.applyMovement();
        break;
      case this.config.up_key:
      case this.config.down_key:
        this.applyVerticalMovement();
        break;
    }
  }

  applyMovement(sprinting) {
    this.player.move(this.getDirection(), sprinting);
  }

  applyVerticalMovement() {
    this.player.moveVertically(this.getVerticalDirection());
  }

  getDirection() {
    return (
      (this.keys[this.config.right_key] || 0) -
      (this.keys[this.config.left_key] || 0)
    );
  }

  getVerticalDirection() {
    return (
      (this.keys[this.config.down_key] || 0) -
      (this.keys[this.config.up_key] || 0)
    );
  }
};
